import {
    getUsers,
} from "../workers/users.worker";

import addUser from "../api/users/addUser";
import editUser from "../api/users/editUser";
import deleteUser from "../api/users/deleteUser";

const UsersStore = {
    namespaced: true,
    state: {
        users: [],
        usersInstance: null,
    },
    getters: {
        all ({ users }) {
            return users;
        },
        isEmailUnique ({ users }) {
            return (email) => {
                return users
                    .map(
                        ({ email }) => email
                    )
                    .includes(email);
            };
        },
    },
    mutations: {
        setUsers (state, users) {
            state.users = users;
        },

        setUsersInterval (state, instance) {
            state.usersInstance = instance;
        },

        addUser (state, user) {
            state.users.push(user);
        },

        editUser (state, newUser) {
            state.users
                .splice(
                    state.users
                        .findIndex(
                            ({ _id }) => _id === newUser._id
                        ),
                    1,
                    newUser
                );
        },

        deleteUser (state, userId) {
            state.users
                .splice(
                    state.users
                        .findIndex(
                            ({ _id }) => _id === userId
                        ),
                    1
                );
        },

        clear (
            state,
        ) {
            state.users = [];
            state.usersInstance = null;
        },
    },
    actions: {
        async loadUsers (
            { commit }
        ) {
            let users;
            try {
                users = await getUsers();
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "setUsers",
                users
            );
            return users;
        },

        async loadUsersRegularly (
            { commit },
            duration = 300000
        ) {
            const intervalId = setInterval(
                async () => {
                    let users;
                    try {
                        users = await getUsers();
                    } catch (e) {
                        console.error(e);
                        throw e;
                    }
                    commit(
                        "setUsers",
                        users
                    );
                },
                duration
            );
            commit(
                "setUsersInterval",
                intervalId
            );
            return intervalId;
        },

        async addUser (
            { commit },
            newUser
        ) {
            let user;
            try {
                user = await addUser(
                    newUser
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "addUser",
                user
            );
            return user;
        },

        async editUser (
            { commit },
            updatedUser
        ) {
            let user;
            try {
                user = await editUser(
                    updatedUser._id,
                    updatedUser
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "editUser",
                user
            );
            return user;
        },

        async deleteUser (
            { commit },
            userId
        ) {
            try {
                await deleteUser(
                    userId
                );
            } catch (e) {
                console.error(e);
                throw e;
            }
            commit(
                "deleteUser",
                userId
            );
        },
    }
};

export default UsersStore;
